// 只要是和报警相关的接口都可以写在这个里面  方便以后查找
import request from '@/utils/request'
// import qs from qs

// 报警跟踪 alarmTrack/queryAllTracking
export function queryAllTracking( pageNum = 1, pageSize = 15, type, custId = '') {
  return request({
    url: '/api/alarmTrack/queryAllTracking',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      type,
      custId
    }

  })
}
// 查询在线设备数量 fireAlarm/fireDevNew
export function fireDev() {
  return request({
    url: '/api/fireAlarm/fireDevNew',
    method: 'get',
    // headers: {
    //   AuthorIzation: token
    // }
  })
}
// water/queryAllCust  // 水系统列表 按设备名称查询
export function queryAllCust() {
  return request({
    url: '/api/water/queryAllCust',
    method: 'get'

  })
}

// 报警跟踪 的接口
// 报警跟踪单位下拉 ,GET , /alarmTrack/findCustByUserRole
export function findCustByUserRole(token) {
  return request({
    url: '/api/alarmTrack/findCustByUserRole',
    method: 'get'
  })
}

// 报警跟踪数据分析 GET /alarmTrack/dataProcess
export function dataProcess({
  token,
  ...params
}) {
  return request({
    url: '/api/alarmTrack/dataProcess',
    method: 'get',
    params
    // headers: {
    //   AuthorIzation: token
    // }
  })
}
//
export function custId(token) {
  return request({
    url: '/api/cust/custId',
    method: 'get'
    // headers: {
    //   AuthorIzation: token
    // }
  })
}

// 单位建筑 接口

// 点击查看 /cust/responsibilityContent

export function responsibilityContent({
  ...params
}) {
  console.log(params)
  return request({
    url: '/api/cust/responsibilityContent',
    method: 'GET',
    params
  })
}

export function findFireSys() {
  return request({
    url: '/api/cust/findFireSys',
    method: 'GET',
    // params
    // headers: {
    //   AuthorIzation: token
    // }
  })
}



// 查询单位消防设施列表
export function findCustFacListByBuildingId({
  token,
  ...params
}) {
  return request({
    url: '/api/cust/findCustFacListByBuildingId',
    method: 'GET',
    params

  })
}
// findCustFacListByBuildingId

// /cust/insertProduct // 可能不在需要了
// 添加产品
export function insertProduct(token, data) {
  return request({
    url: '/api/cust/insertProduct',
    method: 'POST',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}

// /button/pressButton  按钮按下请求接口  GET

export function pressButton(token, flag) {
  return request({
    url: '/api/button/pressButton?flag=' + flag,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  })
}
// /button/cycleRequest
export function cycleRequest(token) {
  return request({
    url: '/api/button/cycleRequest',
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  })
}

// /button/chooseDutysByDutyId  获取职责内容 id 职责ID GET
export function chooseDutysByDutyId(token, id) {
  return request({
    url: '/api/button/chooseDutysByDutyId?id=' + id,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  })
}
// /button/chooseDutys 职责下拉选择接口  GET
export function chooseDutys(token) {
  return request({
    url: '/api/button/chooseDutys',
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  })
}

// ===============独立设备=============================烟温一体==========

export function queryDevList(token, data) {
  return request({
    url: '/api/stdev/queryDevList',
    method: 'GET',
    params: data,
    headers: {
      'content-type': 'application/json'
    }
  })
}
// /stdev/insertDevice 新增烟温一体设备
export function StdevInsertDevice(token, data) {
  const {
    productId,
    deviceName,
    imei,
    masterKey
  } = data
  return request({
    url: `/api/stdev/insertDevice?productId=${productId}&deviceName=${deviceName}&imei=${imei}&masterKey=${masterKey}`,
    method: 'POST',

    headers: {
      'content-type': 'application/json'
    }
  })
}
// 烟温一体的消音按钮
export function stdevDeviceMute(token, data) {
  const {
    masterKey,
    deviceId,
    productId,
    imei
  } = data
  return request({
    url: '/api/stdev/deviceMute?masterKey=' + masterKey + '&deviceId=' + deviceId + '&productId=' + productId + '&imei=' + imei,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    }
  })
}

// 查询设备报警数据 /stdev/queryAlarmByDevId
export function queryAlarmByDevId(token, data) {
  const {
    deviceId,
    pageNum1,
    pageSize1
  } = data
  return request({
    url: '/api/stdev/queryAlarmByDevId',
    method: 'GET',
    params: {
      deviceId: deviceId,
      pageNum: pageNum1,
      pageSize: pageSize1
    },
    headers: {
      'content-type': 'application/json'
    }
  })
}

// /stdev/updateDevName  设备名称修改  PUT devId 设备ID  devName设备名
export function updateDevName(token, data) {
  return request({
    url: `/api/stdev/updateDevName?devId=${data.devId}&&devName=${data.devName}`,
    method: 'PUT',
    params: {},
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 贴图图片上传
export function picturessaving(token, data) {
  // const { productId, deviceName, imei, masterKey } = data
  const {
    typeId,
    imageId
  } = data
  return request({
    url: `http://iot.lituo119.com/3dbim//bim3d/insertBimImage?typeId=${typeId}&imageIds=${imageId}`,
    method: 'POST',
    headers: {
      appkey: token,
      'content-type': 'application/json'
    }
  })
}

// 添加消防系统
export function Addsystem(token, data) {
  const {
    sysName
  } = data
  return request({
    url: 'http://iot.lituo119.com/3dbim//bim3d/insertFireSystem?sysName=' + sysName,
    method: 'POST',
    headers: {
      appkey: token,
      'content-type': 'application/json'
    }
  })
}
// 修改消防系统
export function modifysystem(token, data) {
  const {
    sysName,
    sysId
  } = data
  return request({
    url: 'http://iot.lituo119.com/3dbim//bim3d/insertFireSystem?sysName=' + sysName + '&sysId=' + sysId,
    method: 'POST',
    headers: {
      appkey: token,
      'content-type': 'application/json'
    }
  })
}
// 添加消防设施类型
export function Addfacilitytype(token, data) {
  const {
    facilityName,
    deviceType
  } = data
  return request({
    url: `http://iot.lituo119.com/3dbim//bim3d/insertFireFacility?facilityName=${facilityName}&deviceType=${deviceType}`,
    method: 'POST',
    headers: {
      appkey: token,
      'content-type': 'application/json'
    }
  })
}

// 修改消防设施类型
export function Modifyfacilitytype(token, data) {
  const {
    facilityName,
    deviceType,
    typeId
  } = data
  return request({
    url: `http://iot.lituo119.com/3dbim//bim3d/insertFireFacility?facilityName=${facilityName}&typeId=${typeId}&deviceType=${deviceType}`,
    method: 'POST',
    headers: {
      appkey: token,
      'content-type': 'application/json'
    }
  })
}
// 添加消防设施
export function Addfacilitiesone(token, data) {
  const {
    typeId,
    builidngId,
    localX,
    localY,
    localZ,
    floorNum,
    moudleId,
    mainKey,
    facilityName
  } = data
  return request({
    url: 'http://iot.lituo119.com/3dbim//bim3d/insertFireFacs?typeId=' + typeId + '&builidngId=' + builidngId + '&localX=' + localX + '&localY=' + localY + '&localZ=' + localZ + '&floorNum=' + floorNum + '&moudleId=' + moudleId + '&mainKey=' + mainKey + '&facilityName=' + facilityName,
    method: 'POST',
    headers: {
      appkey: token,
      'content-type': 'application/json'
    }
  })
}
// 修改消防设施
export function Addfacilitiestwo(token, data) {
  const {
    id,
    typeId,
    builidngId,
    localX,
    localY,
    localZ,
    floorNum,
    moudleId,
    mainKey,
    facilityName
  } = data
  return request({
    url: 'http://iot.lituo119.com/3dbim//bim3d/insertFireFacs?typeId=' + typeId + '&id=' + id + '&builidngId=' + builidngId + '&localX=' + localX + '&localY=' + localY + '&localZ=' + localZ + '&floorNum=' + floorNum + '&moudleId=' + moudleId + '&mainKey=' + mainKey + '&facilityName=' + facilityName,
    method: 'POST',
    headers: {
      appkey: token,
      'content-type': 'application/json'
    }
  })
}
// 温湿度计添加设备
// /temhum/insertDevice 新增烟温一体设备
export function Temperaturehumidity(token, data) {
  const {
    productId,
    deviceName,
    imei,
    masterKey
  } = data
  return request({
    url: `/api/temhum/insertDevice?productId=${productId}&deviceName=${deviceName}&imei=${imei}&masterKey=${masterKey}`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 温湿度计修改事件
export function modifythree(token, data) {
  const {
    deviceId,
    temMax,
    temMin,
    humMax,
    humMin,
    deviceName,
    productId,
    masterKey,
    time
  } = data
  return request({
    url: `/api/temhum/setAlarmArea?deviceId=${deviceId}&temMax=${temMax}&temMin=${temMin}&humMax=${humMax}&humMin=${humMin}&deviceName=${deviceName}&productId=${productId}&masterKey=${masterKey}&time=${time}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    }
    // params: {}
  })
}
// /co/insertDevice望家一氧化碳 可燃气体检测
export function coInsertDevice(token, data) {
  const {
    productId,
    deviceName,
    imei,
    masterKey
  } = data
  return request({
    url: `/api/co/insertDevice?productId=${productId}&deviceName=${deviceName}&imei=${imei}&masterKey=${masterKey}`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    }
  })
}
// /smoking/insertDevice
export function smoking(token, data) {
  const {
    productId,
    deviceName,
    imei,
    masterKey
  } = data
  return request({
    url: `/api/smoking/insertDevice?productId=${productId}&deviceName=${deviceName}&imei=${imei}&masterKey=${masterKey}`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 百度地图上建筑坐标
// cust/queryBuildingList
export function queryBuildingList( data, custId) {
  return request({
    url: `/api/cust/queryBuildingList?pCode=${data.pCode}&cCode=${data.cCode}&aCode=${data.aCode}&custId=${custId}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  })
}

export function queryAlarmToDay(token, BULDING_ID, pageNum, pageSize) {
  return request({
    url: `/api/fireAlarm/queryAlarmToDay?buildingId=${BULDING_ID}&pageNum=${pageNum}&pageSize=${pageSize}`,
    method: 'GET'

  })
}
// 百度地图弹框水设备信息
// /water/countByDays
export function countByDays(token, CUST_ID) {
  return request({
    url: `/api/water/countByDays?custId=${CUST_ID}`,
    // url: `/api/water/countByDays`,
    method: 'GET'

  })
}
